// libs
import type { ReactElement } from 'react';
// components
import Page403 from '../statusPages/Page403';
// services
import useAuthorization from './authorizationService';
import { Permission } from './utils';

type ProtectedRouteProps = {
  path?: string;
  exact?: boolean;
  permissionToCheck: Permission | Permission[];
  children: ReactElement;
};

const ProtectedRoute = (props: ProtectedRouteProps) => {
  const { isGranted } = useAuthorization();
  const { permissionToCheck, children } = props;

  return isGranted(permissionToCheck) ? children : <Page403 />;
};

export default ProtectedRoute;
